import { ReactComponent as LinesIcon } from '../../../../../assets/icons/Navegation/lineas.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const PortabilityReportsMenu = ({
  userPermissions,
  openMenuReportsPortability,
  handleClickReportsPortability,
  activeStyle,
  drawerOpen,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('SUPPORT_TICKETS_SUPERVISOR') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='SUPPORT_TICKETS_SUPERVISOR'
          to='/download/portability'
          title='Descargar archivos portabilidades'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('SUPPORT_TICKETS_SUPERVISOR') && (
        <>
          <GenericListItemButton
            onClick={drawerOpen ? handleClickReportsPortability : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Portabilidades'
            IconComponent={(props) => <LinesIcon style={icons} {...props} />}
            openMenu={openMenuReportsPortability}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuReportsPortability}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default PortabilityReportsMenu;
